import store from '@/store';
import { applyReplacementTags } from '@/utilities/Utilities';
import { watch } from 'vue';
import { SdkReplacementTagModel } from '../models/replacementTags';
import { SdkTypeCheck } from '../utilities';

export class SdkReplacementTagsApi {
  public static async applyTag(value: string) {
    await store.getters['campaign/readyPromise'];

    try {
      SdkTypeCheck('string', value);

      return applyReplacementTags(value);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  }

  public static async getAll() {
    await store.getters['campaign/readyPromise'];

    return SdkReplacementTagsApi.getReplacementTags();
  }

  public static async setTag(key: string, value: string) {
    await store.getters['campaign/readyPromise'];
    try {
      SdkTypeCheck('string', key);
      SdkTypeCheck('string', value);

      store.dispatch('global/setReplacementTags', { [key]: value });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  }

  private static getReplacementTags() {
    const replacementTags = store.getters['global/replacementTags'];

    return Object.keys(replacementTags).map((key) => {
      return new SdkReplacementTagModel(key, replacementTags[String(key)]).tag;
    });
  }

  public static onChange(fn: (value: string | number) => void, name?: string) {
    try {
      if (name) {
        SdkTypeCheck('string', name);
        return watch(
          () => store.getters['global/replacementTags'][`${name}`],
          (newValue) => {
            fn(newValue);
          }
        );
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  }

  public static onChangeOnce(fn: (value: string | number) => void, name?: string) {
    const stopHandler = this.onChange((value) => {
      if (stopHandler) {
        fn(value);
        stopHandler();
      }
    }, name);

    return stopHandler;
  }
}
